import React, { useState, useEffect } from "react";
import useFirestoreCollection from "../utils/useFirestoreCollection";
import "../Styles/WorkingHours.css";

const WorkingHours = () => {
  const { loading, error, data } = useFirestoreCollection("hours");
  const { data: adminData } = useFirestoreCollection("administration");
  const [isWinter, setIsWinter] = useState(null);

  useEffect(() => {
    if (adminData && adminData.length > 0) {
      setIsWinter(adminData[0].isWinter);
    }
  }, [adminData]);

  if (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }

  return (
    <div className="working-hours">
      {loading && <p className="working-hours__loading">Loading…</p>}
      {!loading && !error && (
        <>
          {!isWinter ? (
            <ul className="working-hours-list">
              {data.map((day) => (
                <li key={day.id}>
                  <span className="day">{day.day}</span>
                  {day.isOpen ? (
                    <span className="opening-time">{day.opening}</span>
                  ) : (
                    <span className="closed">Closed</span>
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <p className="working-hours__winter">
              The restaurant is currently
              <br />
              <strong>Closed for the winter season</strong>
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default WorkingHours;
